module.exports = __webpack_public_path__ + "img/paper-2.27dd31e8.png";